// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","funeral-home-profile":"funeral-home-profile","upcoming-services-tab":"upcoming-services-tab","upcoming-services-tab__events-container":"upcoming-services-tab__events-container","upcoming-services-tab__image":"upcoming-services-tab__image"};


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/Profile/components/Tabs/UpcomingServices/css/UpcomingServices.styl
// module id = 1544
// module chunks = 0